var finansudd = finansudd || {};

finansudd.forms = new function(){

    var self = this;


    this.init = function () {

        self.addId();
        self.toggleClassEffect();
        self.dialogModal();
        self.validation();

	};

    this.validation = function () {
        var $form = $('.validate-form form');
        
        // Bind the parsley validation if form exists
        if ($form.length) {

            $form.parsley({
                errorClass: 'has-error',
                successClass: 'has-success',
                classHandler: function (ParsleyField) {
                    return ParsleyField.$element.parents('.form-group');
                 },
                errorsContainer: function (ParsleyField) {
                   return ParsleyField.$element.parents('.form-group');
                },
                errorsWrapper: '<span class="error-block">',
                errorTemplate: '<div></div>'
            });

        }
    }

    this.addId = function () {
        var form = $(".contour");

        form.each(function (index) {

            var formId = $(this).attr("id");
            var form = $(this).find("form")
            var formAction = form.attr("action");

            form.attr("action", formAction + "#" + formId);
        });
    };


    this.toggleClassEffect = function() {
        // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
        var $input = $('.form-group > input, .form-group > textarea');

        $input.each(function() {
            var $this = $(this);

            $this.focus(function() {
                $(this).parent().addClass('has-been-focused');
                $(this).parent().addClass('is-focused');
            });

            $this.blur(function() {
                $(this).parent().removeClass('is-focused');
            });


        });

    };

    this.dialogModal = function() {
        var $modal = $('.modal.auto-open');

        if ($modal.length) {
            $modal.modal('show');
        }

    };

};